import React, { memo } from 'react';
import { CTAButton } from './CTAButton';
export const TomosSection = memo(function TomosSection() {
  const tomos = [{
    icon: '⚡',
    title: 'Tomo 1 — Fundamentos y Seguridad',
    subtitle: 'De cero absoluto a trabajar sin riesgos desde el día uno',
    desc: 'Entendés cómo funciona la electricidad, dominás el protocolo de seguridad y arrancás con las herramientas mínimas necesarias.',
    result: 'Trabajar con seguridad total desde el primer día.',
    value: '$8.900'
  }, {
    icon: '🔧',
    title: 'Tomo 2 — Reparaciones Domiciliarias',
    subtitle: 'Resolvé el 80% de las fallas del hogar con tus propias manos',
    desc: 'Reemplazás tomacorrientes, llaves de luz, hacés empalmes e instalás iluminación LED con sensores sin depender de nadie.',
    result: 'Independencia total para mantener cualquier hogar.',
    value: '$8.900'
  }, {
    icon: '🗂️',
    title: 'Tomo 3 — Tableros y Protecciones',
    subtitle: 'Dominá el componente que más miedo genera y más poder tiene',
    desc: 'Entendés térmicas, diferenciales y puesta a tierra. Diagnosticás por qué salta el diferencial y lo resolvés de forma sistemática.',
    result: 'Leer y diagnosticar cualquier tablero con confianza total.',
    value: '$8.900'
  }, {
    icon: '🏗️',
    title: 'Tomo 4 — Instalaciones desde Cero',
    subtitle: 'Creá instalaciones eléctricas completas en obra nueva',
    desc: 'Leés planos, instalás canalizaciones, armás tableros y presupuestás obras reales de principio a fin.',
    result: 'Cotizar y ejecutar instalaciones completas como un profesional.',
    value: '$8.900'
  }, {
    icon: '📋',
    title: 'Tomo 5 — Profesionalización',
    subtitle: 'Del electricista que trabaja al profesional que cobra bien',
    desc: 'Normativa AEA 90364, mediciones certificadas y gestión de tu propio negocio eléctrico.',
    result: 'Emitir informes certificados y construir tu cartera de clientes.',
    value: '$8.900'
  }, {
    icon: '🤖',
    title: 'Tomo 6 — Maestría y Automatización',
    subtitle: 'Smart Home, trifásico y energía solar: el mercado del futuro',
    desc: 'Dominás porteros IP, tableros trifásicos, automatización con relés y los fundamentos de la energía solar fotovoltaica.',
    result: 'Acceder al mercado de mayor crecimiento y menor competencia.',
    value: '$8.900'
  }];
  return <section className="py-16 bg-gray-900 text-white overflow-hidden" data-id="element-200">
      <div className="max-w-5xl mx-auto px-4" data-id="element-201">
        {/* Header */}
        <div className="text-center mb-10" data-id="element-202">
          <h2 className="text-[26px] md:text-4xl font-black text-white mb-4 leading-tight" data-id="element-203">
            Todo lo que Contiene tu{' '}
            <span className="text-blue-500" data-id="element-204">Megapack Eléctrico PRO:</span>
          </h2>
          <p className="text-gray-500 text-[13px] md:hidden" data-id="element-205">
            Deslizá para ver todos los tomos 👈
          </p>
        </div>
      </div>

      {/* Carrusel Horizontal en mobile, grid centrado en desktop */}
      <div className="flex gap-4 overflow-x-auto scroll-smooth snap-x snap-mandatory pb-6 px-[10vw] md:overflow-visible md:flex-wrap md:justify-center md:max-w-6xl md:mx-auto md:px-4 scrollbar-hide" data-id="element-206">
        {tomos.map((tomo, index) => <div key={index} className="snap-center flex-shrink-0 w-[80vw] md:w-[340px] bg-gray-800 rounded-2xl border border-gray-700 p-6 shadow-xl hover:border-blue-500/50 transition-all duration-300 flex flex-col" data-id="element-207">
            {/* Header card */}
            <div className="mb-4" data-id="element-208">
              <div className="flex items-center gap-3 mb-2" data-id="element-209">
                <span className="text-3xl bg-gray-900 p-2 rounded-lg border border-gray-700" data-id="element-210">
                  {tomo.icon}
                </span>
                <h3 className="text-[17px] font-black text-white leading-tight" data-id="element-211">
                  {tomo.title}
                </h3>
              </div>
              <p className="text-blue-400 font-bold text-[13px] leading-snug mt-3" data-id="element-212">
                "{tomo.subtitle}"
              </p>
            </div>

            {/* Desc */}
            <p className="text-gray-400 text-[13px] leading-relaxed mb-5 flex-1" data-id="element-213">
              {tomo.desc}
            </p>

            {/* Result */}
            <div className="bg-blue-500/10 border border-blue-500/20 rounded-xl p-4 mb-4" data-id="element-214">
              <p className="text-[12px]" data-id="element-215">
                <strong className="text-blue-400" data-id="element-216">Lo que lográs:</strong>{' '}
                <span className="text-gray-300" data-id="element-217">{tomo.result}</span>
              </p>
            </div>

            {/* Valor */}
            <div className="flex items-center justify-between border-t border-gray-700 pt-4 mt-auto" data-id="element-218">
              <span className="text-gray-500 text-[11px] font-bold uppercase tracking-wider" data-id="element-219">
                Valor Real
              </span>
              <span className="text-gray-400 font-bold line-through" data-id="element-220">
                {tomo.value}
              </span>
            </div>
          </div>)}
      </div>

      {/* Dots indicadores mobile */}
      <div className="flex justify-center gap-2 mt-4 md:hidden" data-id="element-221">
        {tomos.map((_, index) => <div key={index} className="w-2 h-2 rounded-full bg-gray-600" data-id="element-222" />)}
      </div>

      {/* CTA */}
      <div className="max-w-5xl mx-auto px-4 mt-12" data-id="element-223">
        <CTAButton href="#compra" text="⚡ ACCEDÉ AL MEGAPACK COMPLETO AHORA" subtext="🔒 Compra protegida por MercadoPago — Garantía 30 días" data-id="element-224" />
      </div>
    </section>;
});